<script lang="ts" setup>
import { toRefs } from 'vue';

interface PropsInterface {
  name: string | undefined;
}

const props = defineProps<PropsInterface>();
const { name } = toRefs(props);

const getCustomName = () => {
  return name.value;
};
</script>

<template>
  <div class="overflow-hidden text-dark inline-flex align-items-baseline">
    <div class="text-ellipsis">
      <span class="font-bold text-ellipsis">{{ getCustomName() }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.text-dark {
  color: var(--surface-900);
}

.group-icon {
  color: var(--gray-700);
  position: relative;
  top: 3px;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  display: block;
}
</style>
